import React from 'react';
import PropTypes from 'prop-types';
import './hero.scss';
import heroImage from '../../assets/images/st-dominics-5.jpg';
const Hero = ({ title, subtitle, cta, secondaryCta, onCtaClick, onSecondaryCtaClick }) => (
  <div
    className="hero"
    style={{ 
      backgroundImage: `url(${heroImage})`, 
      backgroundSize: 'cover', 
      backgroundPosition: 'center'
    }}
  >
    <div className="container">
      <div className="row align-items-center min-vh-75">
        <div className="col-lg-8 mx-auto text-center">
          <div className="hero-content">
            <h1 className="hero-title">{title}</h1>
            <h2 className="hero-subtitle">{subtitle}</h2>
            <div className="hero-actions">
              <button className="btn btn-outline-light btn-lg me-4" onClick={onCtaClick}>
                {cta}
              </button>
              {secondaryCta && (
                <button className="btn btn-gradient btn-lg" onClick={onSecondaryCtaClick}>
                  {secondaryCta}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="hero-overlay"></div>
  </div>
);

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  secondaryCta: PropTypes.string,
  onCtaClick: PropTypes.func,
  onSecondaryCtaClick: PropTypes.func,
};

export default Hero; 